// 订单项
export const orderTitle = "<table style='width: 100%; border-collapse:collapse; border: 1px solid black; text-align: left; margin-bottom: 20px; padding: 5px'>" +
	"<tr style='border: 1px solid black;  text-align: center'>" +
	"<td style='border: 1px solid black; width: 60px;'>序号</td>" +
	"<td style='border: 1px solid black; min-width:80px;'>订单项号</td>" +
	"<td style='border: 1px solid black; min-width:60px;'>品牌</td>" +
	"<td style='border: 1px solid black; min-width:60px;'>分类</td>" +
	"<td style='border: 1px solid black; 'min-width:80px;>货号</td>" +
	"<td style='border: 1px solid black; min-width: 60px;'>颜色</td>" +
	"<td style='border: 1px solid black; min-width: 60px;'>规格</td>" +
	"<td style='border: 1px solid black; min-width: 60px;'>数量</td>" +
	"<td style='border: 1px solid black; min-width: 80px;'>交货日期</td>" +
	"<td style='border: 1px solid black; min-width: 50px;'>价格</td>" +
	"<td style='border: 1px solid black; min-width: 80px;'>折扣%</td>" +
	"<td style='border: 1px solid black; min-width: 60px;'>成交单价</td>" +
	"<td style='border: 1px solid black; min-width: 60px;'>附加费</td>" +
	"<td style='border: 1px solid black; min-width: 80px; '>小计</td>" +
	"</tr>"
// 精简订单项
export const orderTitleSimple = "<table style='width: 100%; border-collapse:collapse; border: 1px solid black; text-align: left; margin-bottom: 20px; padding: 5px'>" +
	"<tr style='border: 1px solid black;  text-align: center'>" +
	"<td style='border: 1px solid black; width: 60px;'>序号</td>" +
	"<td style='border: 1px solid black; min-width:80px;'>货号</td>" +
	"<td style='border: 1px solid black; min-width: 60px;'>颜色</td>" +
	"<td style='border: 1px solid black; min-width: 60px;'>规格</td>" +
	"<td style='border: 1px solid black; min-width: 60px;'>数量</td>" +
	"<td style='border: 1px solid black; min-width: 100px;'>交货日期</td>" +
	"<td style='border: 1px solid black; min-width: 60px;'>成交单价</td>" +
	"<td style='border: 1px solid black; min-width: 80px;'>附加费</td>" +
	"<td style='border: 1px solid black; min-width: 80px; '>小计</td>" +
	"</tr>"
// 订单项 带图片
export const orderTitleWidthImage = "<table style='width: 100%; border-collapse:collapse; border: 1px solid black; text-align: left; margin-bottom: 20px; padding: 5px'>" +
	"<tr style='border: 1px solid black;  text-align: center'>" +
	"<td style='border: 1px solid black; width: 60px;'>序号</td>" +
	"<td style='border: 1px solid black; width: 80px'>图片</td>" +
	"<td style='border: 1px solid black; min-width: 80px;'>订单项号</td>" +
	"<td style='border: 1px solid black; min-width: 80px; '>品牌</td>" +
	"<td style='border: 1px solid black; min-width: 80px;'>分类</td>" +
	"<td style='border: 1px solid black; min-width: 80px;'>货号</td>" +
	"<td style='border: 1px solid black; min-width: 60px;'>颜色</td>" +
	"<td style='border: 1px solid black; min-width: 60px;'>规格</td>" +
	"<td style='border: 1px solid black; min-width: 60px;'>数量</td>" +
	"<td style='border: 1px solid black; min-width: 80px;'>交货日期</td>" +
	"<td style='border: 1px solid black; min-width: 60px;'>价格</td>" +
	"<td style='border: 1px solid black; min-width: 80px;'>折扣%</td>" +
	"<td style='border: 1px solid black; min-width: 80px;'>成交单价</td>" +
	"<td style='border: 1px solid black; min-width: 80px;'>附加费</td>" +
	"<td style='border: 1px solid black; min-width: 80px; '>小计</td>" +
	"</tr>"
// 精简订单项 带图片
export const orderTitleSimpleWidthImage = "<table style='width: 100%; border-collapse:collapse; border: 1px solid black; text-align: left; margin-bottom: 20px; padding: 5px'>" +
	"<tr style='border: 1px solid black;  text-align: center'>" +
	"<td style='border: 1px solid black; width: 60px;'>序号</td>" +
	"<td style='border: 1px solid black; min-width: 80px'>图片</td>" +
	"<td style='border: 1px solid black; min-width: 80px'>货号</td>" +
	"<td style='border: 1px solid black; min-width: 60px;'>颜色</td>" +
	"<td style='border: 1px solid black; min-width: 60px;'>规格</td>" +
	"<td style='border: 1px solid black; min-width: 80px;'>数量</td>" +
	"<td style='border: 1px solid black; min-width: 80px;'>交货日期</td>" +
	"<td style='border: 1px solid black; min-width: 60px;'>成交单价</td>" +
	"<td style='border: 1px solid black; min-width: 80px;'>附加费</td>" +
	"<td style='border: 1px solid black; min-width: 80px; '>小计</td>" +
	"</tr>"

// 精简订单项 带图片
export const orderTitleOrderContents5 = "<table style='width: 100%; border-collapse:collapse; border: 1px solid black; text-align: left; margin-bottom: 20px; padding: 5px'>" +
	"<tr style='border: 1px solid black;  text-align: center'>" +
	"<td style='border: 1px solid black; width: 60px;'>序号</td>" +
	"<td style='border: 1px solid black; min-width: 80px'>货号</td>" +
	"<td style='border: 1px solid black; min-width: 60px;'>颜色</td>" +
	"<td style='border: 1px solid black; min-width: 60px;'>规格</td>" +
	"<td style='border: 1px solid black; min-width: 80px;'>数量</td>" +
	"<td style='border: 1px solid black; min-width: 60px;'>成交单价</td>" +
	"<td style='border: 1px solid black; min-width: 80px; '>备注</td>" +
	"</tr>"

	// 销售单打印模板增加${ 带图片订单项 } ${ 带图片精简订单项 } 变量
